export default "__VITE_ASSET__tgttW1fe__";